<dx-scroll-view [showScrollbar]="'always'" height="100%">
  
  <ng-container *ngIf="this.parameters.isSingleDirection; then single; else double"></ng-container>

</dx-scroll-view>

<ng-template #single>
  <div class="parameters">
    
    <!-- display name -->
    <div *ngIf="!this.parameters.manualMode" class="row-2">
      <div class="label">Display Name</div>
      <div class="input">
        <dx-text-box [(value)]="this.parameters.displayName"></dx-text-box>
      </div>
    </div>
    
    <!-- roll [x] days before expiration -->
    <div *ngIf="!this.parameters.manualMode" class="row-2">
      <div class="label">
        Roll [x] Days Before Expiration
      </div>
      <div class="input">
        <dx-number-box [(value)]="this.parameters.rollDaysBeforeExpiration"
                       [min]="0"
                       [step]="1"
                       format="0#d"></dx-number-box>
      </div>
    </div>
    
    <!-- roll time -->
    <div *ngIf="!this.parameters.manualMode && this.cpMode !== 'Automated' " class="row-2">
      <div class="label">Roll Time & Mode</div>
      <div class="input">
        <div class="roll-mode">
          <p>Mode</p>
          <dx-select-box [(value)]="this.parameters.rollTimeMode"
                         [items]="this.parameters.rollTimeModes"></dx-select-box>
        </div>
        <br>
        <div class="roll-time">
          <p>Time</p>
          <ets-datetime-picker [(value)]="this.parameters.rollTime"
                               [contextWord]="this.parameters.rollTimeMode"
                               [mode]="this.parameters.rollTimePickerMode" [showTimezone]="false">
          </ets-datetime-picker>
          <div *ngIf="this.parameters.rollTimePickerShowTimezone" style="margin-top: 5px;">
            <ets-timezone-picker
              [(timezone)]="this.parameters.rollTimezone"
              [flow]="'col'">
            </ets-timezone-picker>
          </div>
        </div>
      </div>
    </div>
    
    <!-- epxiration to roll to offset -->
    <div *ngIf="!this.parameters.manualMode" class="row-2">
      <div class="label">Roll To Days To Expiration</div>
      <div class="input">
        <div class="expiration-offset-mode">
          <p>Mode</p>
          <dx-select-box [(value)]="this.parameters.expirationOffsetMode"
                         [items]="this.parameters.getExpirationOffsetModes(this.cpMode)"></dx-select-box>
        </div>
        <br>
        <div class="expiration-offset-value">
          <p>Value</p>
          <dx-number-box [(value)]="this.parameters.expirationOffsetValue"
                         [format]="this.parameters.expirationValueOffsetFormat" [min]="1"
                         [step]="1"></dx-number-box>
        </div>
        <br>
        <div class="expiration-offset-rolltobuffer">
          <p>Expiration Preference (if unavailble)</p>
          <dx-select-box [(value)]="this.parameters.expirationPreference" [items]="['Near', 'Far']"></dx-select-box>
        </div>
      </div>
    </div>
    
    <!-- expirations -->
    <div *ngIf="this.parameters.manualMode" class="row-2">
      <div class="label">
        Expiration
      </div>
      <div class="input">
        
        <ets-expiration-selector
          [(selectedExpiration)]="this.parameters.manualModeSettings.expiration"
          [expirationDescriptors]="this.parameters.expirations"
          [showClearButton]="true"
        ></ets-expiration-selector>
        
<!--        <dx-select-box -->
<!--          [(value)]="this.parameters.manualModeSettings.expiration" [inputAttr]="this.parameters.manualModeSettings?.expiration?.expirationTicker === '@SPX' ? {'style': 'color: yellow'} : {}"-->
<!--                       [items]="this.parameters.expirations"-->
<!--                       [showClearButton]="true"-->
<!--                       displayExpr="dateWithDaysToExpiration">-->
<!--          <div *dxTemplate="let data of 'item'">-->
<!--                  <span [style.color]="(data?.expirationTicker === '@SPX' ? 'yellow' : '')">-->
<!--                     {{ data?.dateWithDaysToExpiration }}-->
<!--                  </span>-->
<!--          </div>-->
<!--        </dx-select-box>-->
      </div>
    </div>
    
    <!-- spread width -->
    <div class="row-2">
      <div class="label">Spread Width</div>
      <div class="input">
        <dx-number-box [(value)]="this.parameters.spreadWidth"
                       [min]="1" format="$#0"></dx-number-box>
      </div>
    </div>
    
    <!-- ATM Offset -->
    <div class="row-2">
      <div class="label">ATM Offset</div>
      <div class="input">
        <dx-number-box [(value)]="this.parameters.atmOffset" [min]="0" format="$#0"></dx-number-box>
      </div>
    </div>
    
    <!-- ATM Neutral Zone -->
    <div *ngIf="this.cpMode !== 'Automated'" class="row-2">
      <div class="label">ATM Neutral Zone</div>
      <div class="input">
        <dx-number-box [(value)]="this.parameters.atmNeutralZone"
                       [min]="0"
                       [step]="0.01"
                       format="#0%"></dx-number-box>
      </div>
    </div>
    
    <!-- order type -->
    <div *ngIf="this.cpMode !== 'Automated'" class="row-2">
      <div class="label">Order Type</div>
      <div class="input">
        <dx-select-box [(value)]="this.parameters.orderType"
                       [items]="this.parameters.orderTypes"
                       displayExpr="text"
                       valueExpr="value">
        </dx-select-box>
        
        <br>
        
        <!-- ctm -->
        <div *ngIf="this.parameters.orderType === 1">
          
          <div class="row-2">
            <div class="label">Limit Price</div>
            <div class="input">
              <dx-select-box [(value)]="this.parameters.autoLimitPrice"
                             [items]="['Bid', 'Mid', 'Ask']">
              </dx-select-box>
            </div>
          </div>
          
          <div style="margin-top: -12px;">
            <fieldset>
              <legend>
                <dx-check-box #ctm
                              (onValueChanged)="this.parameters.onChange()"
                              [(value)]="this.parameters.convertToMarket"
                              text="Convert To Market"
                >
                </dx-check-box>
              </legend>
              
              <ets-convert-to-market *ngIf="ctm.value"
                                     [hideCalendar]="true"
                                     [settings]="this.parameters.convertToMarketSettings">
              </ets-convert-to-market>
            </fieldset>
          </div>
        
        </div>
      </div>
    </div>
    
    <!-- FO settings -->
    <div *ngIf="this.parameters.manualMode" class="row-2">
      <div class="label">FO Settings</div>
      <div class="input">
        <fieldset>
          <legend>
            <dx-check-box #fo [(value)]="this.parameters.isFutureOrder" text="Future Time Settings"></dx-check-box>
          </legend>
          
          <div *ngIf="this.parameters.manualModeSettings.isFutureOrder" class="fo-settings">
            
            <div class="row">
              
              <div class="block">
                <dx-select-box
                  #place
                  (onValueChanged)="this.parameters.onChange()"
                  [(value)]="this.parameters.manualModeSettings.futureTimeSettings.actionTimeMode"
                  [disabled]="!fo.value" [items]="['Place At', 'Place After']"
                  [showClearButton]="true"
                  placholder="Place Mode"
                ></dx-select-box>
              </div>
              
              <div class="block">
                <ets-datetime-picker
                  (onValueChanged)="this.parameters.onChange()"
                  [(value)]="this.parameters.manualModeSettings.futureTimeSettings.actionTime"
                  [contextWord]="this.parameters.manualModeSettings.futureTimeSettings.actionTimeMode"
                  [disabled]="!place.value"
                  [mode]="this.parameters.dateTimePickerModeForFutureSettings"
                ></ets-datetime-picker>
              </div>
            
            </div>
            
            <div *ngIf="this.parameters.manualModeSettings.futureTimeSettings.actionTimeMode === 'Place At'" class="input row"
                 style="margin-top: 5px;">
              <ets-timezone-picker
                [(timezone)]="this.parameters.manualModeSettings.futureTimeSettings.timezone"
                [flow]="'col'">
              </ets-timezone-picker>
            </div>
          
          </div>
        </fieldset>
      </div>
    </div>
  </div>

</ng-template>

<ng-template #double>
  
  <div class="parameters">
    
    <div class="common">
      
      <!-- ATM Offset -->
      <div class="row-2">
        <div class="label">ATM Offset</div>
        <div class="input">
          <dx-number-box [(value)]="this.parameters.atmOffset" [min]="0" format="$#0"></dx-number-box>
        </div>
      </div>
      
      <!-- roll [x] days before expiration -->
      <div *ngIf="!this.parameters.manualMode" class="row-2">
        <div class="label">
          Roll [x] Days Before Expiration
        </div>
        <div class="input">
          <dx-number-box [(value)]="this.parameters.rollDaysBeforeExpiration"
                         [min]="0"
                         [step]="1"
                         format="0#d"></dx-number-box>
        </div>
      </div>
      
      <!-- epxiration to roll to offset -->
      <div *ngIf="!this.parameters.manualMode" class="row-2">
        <div class="label">Roll To Days To Expiration</div>
        <div class="input">
          <div class="expiration-offset-mode">
            <p>Mode</p>
            <dx-select-box [(value)]="this.parameters.expirationOffsetMode"
                           [items]="this.parameters.getExpirationOffsetModes(this.cpMode)"></dx-select-box>
          </div>
          <br>
          <div class="expiration-offset-value">
            <p>Value</p>
            <dx-number-box [(value)]="this.parameters.expirationOffsetValue"
                           [format]="this.parameters.expirationValueOffsetFormat" [min]="1"
                           [step]="1"></dx-number-box>
          </div>
          <br>
          <div class="expiration-offset-rolltobuffer">
            <p>Expiration Preference (if unavailble)</p>
            <dx-select-box [(value)]="this.parameters.expirationPreference" [items]="['Near', 'Far']"></dx-select-box>
          </div>
        </div>
      </div>
    
    </div>
    
    <div class="individual">
      
      <fieldset class="calls">
        <legend>Calls</legend>
        <!-- spread width -->
        <div class="row-2">
          <div class="label">Spread Width</div>
          <div class="input">
            <dx-number-box [(value)]="this.parameters.spreadWidth"
                           [min]="1" format="$#0"></dx-number-box>
          </div>
        </div>
      </fieldset>
      
      <fieldset class="puts">
        <legend>Puts</legend>
        <!-- spread width -->
        <div class="row-2">
          <div class="label">Spread Width</div>
          <div class="input">
            <dx-number-box [(value)]="this.parameters.spreadWidth2"
                           [min]="1" format="$#0"></dx-number-box>
          </div>
        </div>
      </fieldset>
    
    </div>
  
  </div>

</ng-template>
